<style>
</style>
<template>
    <v-container fluid id="my--documents">
        <v-container fluid style="max-width: 960px;">
            <v-data-table
                    item-key="$id"
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    class="mt-4 mb-4"
                    :sort-by="sortBy"
            >
                <template v-slot:item.file.date="{ item }">{{ item.file.date | moment('D.M.Y') }}</template>
                <template v-slot:item.sendDate="{ item }">{{ item.sendDate | moment('D.M.Y') }}</template>
                <template v-slot:item.file.byteSize="{ item }">{{ item.file.byteSize | size }}</template>
                <template v-slot:item.sendDate="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon class="mx-0" @click="download(item)" v-on="on">
                                <v-icon color="teal" class="fa fa-download" aria-hidden="true"></v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('Stáhnout') }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-container>
        <!--    <v-row class="background: grey lighten-1">-->
        <!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--        <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled svých dokumentů') }}</v-alert>-->
        <!--      </v-container>-->
        <!--    </v-row>-->
    </v-container>
</template>
<script>
import DisplayGroupMixin from '@/mixins/display-group-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
    props: {
        documents: {
            type: Array,
            default: null
        }
    },
    mixins: [DisplayGroupMixin, TransformMixin],
    data() {
        return {
            search: null,
            sortBy: ['file.date', 'file.sendDate'],
            headers: [{
                text: 'Datum',
                value: 'file.date',
                align: 'right',
                searchable: true,
                sortable: true
            }, {
                text: 'Typ',
                value: 'file.fileType.name',
                align: 'left',
                searchable: true,
                sortable: true
            }, {
                text: 'Datum odeslání',
                value: 'file.sendDate',
                align: 'right'
            }, {
                text: 'Velikost',
                value: 'file.file.byteSize',
                align: 'right'
            }, {
                text: 'Možnosti',
                value: 'options',
                align: 'center'
            }],
            pagination: {
                'sortBy': 'file.date',
                // 'descending': false,
                'rowsPerPage': 10
            }
        }
    },
    computed: {
        loading() {
            return this.documents === null
        },
        items() {
            return this.documents !== null ? this.documents : []
        }
    },
    methods: {
        download(item) {
            const options = {
                headers: {
                    'accept': 'application/octet-stream'
                }
            }
            this.$fetch('my/institutions/files/' + item.file.fileId, options).then().catch(() => console.log('download file error'))
        }
    }
}
</script>
